// components
import { Outlet } from 'react-router'
import Navbar from '../components/Navbar'
import WhatsAppFloat from '../components/WhatsAppFloat'

const RootLayout = () => {
  return (
    <div className='school'>
      <Navbar />
      <main>
        <Outlet />
      </main>
      <WhatsAppFloat />
    </div>
  )
}

export default RootLayout
